var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "step-1-part-1", autocomplete: "off" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("list-document-types", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "documentTypes",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Tipo Documento (*)",
                  "data-cy": "document-type",
                  name: "documentType",
                  danger: _vm.errors.has("step-1-part-1.documentType"),
                  "danger-text": _vm.errors.first("step-1-part-1.documentType")
                },
                model: {
                  value: _vm.step.documentType,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "documentType", $$v)
                  },
                  expression: "step.documentType"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "documentNumber",
                staticClass: "w-100",
                attrs: {
                  label: "Nº Documento (*)",
                  "data-cy": "document-number",
                  name: "documentNumber",
                  danger: _vm.errors.has("step-1-part-1.documentNumber"),
                  "danger-text": _vm.errors.first(
                    "step-1-part-1.documentNumber"
                  ),
                  autocomplete: "off",
                  "data-vv-as": "nº documento"
                },
                model: {
                  value: _vm.step.documentNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "documentNumber", $$v)
                  },
                  expression: "step.documentNumber"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Empresa (*)" } },
                [
                  _c("v-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100 b-radius",
                    class: {
                      "v-select-danger": _vm.errors.has("step-1-part-1.author"),
                      "select-size-sm": _vm.errors.has("step-1-part-1.author")
                    },
                    attrs: {
                      options: _vm.authorAguasAndinas,
                      clearable: false,
                      "data-cy": "author",
                      name: "author",
                      "data-vv-as": "autor"
                    },
                    model: {
                      value: _vm.step.author,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "author", $$v)
                      },
                      expression: "step.author"
                    }
                  }),
                  _vm.errors.has("step-1-part-1.author")
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "con-text-validation span-text-validation-danger v-enter-to",
                          staticStyle: { height: "19px" }
                        },
                        [
                          _c("span", { staticClass: "span-text-validation" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first("step-1-part-1.author")
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 mt-1" },
            [
              _c("label", [_vm._v("Fecha Documento")]),
              _c(
                "b-form-datepicker",
                _vm._b(
                  {
                    attrs: {
                      "today-button": "",
                      "reset-button": "",
                      "close-button": "",
                      max: _vm.maxDate,
                      locale: _vm.locale,
                      "show-decade-nav": false,
                      "hide-header": false
                    },
                    model: {
                      value: _vm.step.issueDate,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "issueDate", $$v)
                      },
                      expression: "step.issueDate"
                    }
                  },
                  "b-form-datepicker",
                  _vm.labels[_vm.locale] || {},
                  false
                )
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 mt-1" },
            [
              _c("label", [_vm._v("Plazo de gestión")]),
              _c(
                "b-form-datepicker",
                _vm._b(
                  {
                    attrs: {
                      "data-cy": "management-calendar",
                      "today-button": "",
                      "reset-button": "",
                      "close-button": "",
                      min: _vm.minExpirationDate,
                      locale: _vm.locale,
                      "show-decade-nav": false,
                      "hide-header": false
                    },
                    model: {
                      value: _vm.step.expirationDate,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "expirationDate", $$v)
                      },
                      expression: "step.expirationDate"
                    }
                  },
                  "b-form-datepicker",
                  _vm.labels[_vm.locale] || {},
                  false
                )
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Tema (*)" } },
                [
                  _c("v-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100 b-radius",
                    class: {
                      "v-select-danger": _vm.errors.has("step-1-part-1.theme"),
                      "select-size-sm": _vm.errors.has("step-1-part-1.theme")
                    },
                    attrs: {
                      options: _vm.themesAguasAndinas,
                      clearable: false,
                      reduce: function(option) {
                        return option.id
                      },
                      "data-cy": "theme",
                      name: "theme",
                      "data-vv-as": "tema"
                    },
                    model: {
                      value: _vm.step.theme,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "theme", $$v)
                      },
                      expression: "step.theme"
                    }
                  }),
                  _vm.errors.has("step-1-part-1.theme")
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "con-text-validation span-text-validation-danger v-enter-to",
                          staticStyle: { height: "19px" }
                        },
                        [
                          _c("span", { staticClass: "span-text-validation" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first("step-1-part-1.theme")
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Sub-tema (*)" } },
                [
                  _c("v-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100 b-radius",
                    class: {
                      "v-select-danger": _vm.errors.has(
                        "step-1-part-1.subtheme"
                      ),
                      "select-size-sm": _vm.errors.has("step-1-part-1.subtheme")
                    },
                    attrs: {
                      options: _vm.subThemesAguasAndinas,
                      reduce: function(option) {
                        return option.id
                      },
                      clearable: false,
                      "data-cy": "sub-theme",
                      name: "subtheme",
                      "data-vv-as": "sub-tema"
                    },
                    model: {
                      value: _vm.step.subTheme,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "subTheme", $$v)
                      },
                      expression: "step.subTheme"
                    }
                  }),
                  _vm.errors.has("step-1-part-1.subtheme")
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "con-text-validation span-text-validation-danger v-enter-to",
                          staticStyle: { height: "19px" }
                        },
                        [
                          _c("span", { staticClass: "span-text-validation" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first("step-1-part-1.subtheme")
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("label", { attrs: { for: "matter" } }, [
                _vm._v("Materia (*)")
              ]),
              _c("vs-textarea", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|min:3",
                    expression: "'required|min:3'"
                  }
                ],
                staticClass: "mb-0",
                attrs: {
                  type: "text",
                  id: "matter",
                  label:
                    "Materia (Mínimo 3 caracteres, máximo 5000 caracteres)",
                  "data-cy": "matter",
                  name: "matter",
                  width: "100%",
                  height: "100px",
                  maxlength: "5000"
                },
                model: {
                  value: _vm.step.matter,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "matter", $$v)
                  },
                  expression: "step.matter"
                }
              }),
              _vm.errors.first("step-1-part-1.matter")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "con-text-validation span-text-validation-danger\n           vs-input--text-validation-span v-enter-to",
                      staticStyle: { height: "32px" }
                    },
                    [
                      _c("span", { staticClass: "span-text-validation" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.errors.first("step-1-part-1.matter")) +
                            " "
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "text-right" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Contador de caracteres",
                        expression: "'Contador de caracteres'"
                      }
                    ]
                  },
                  [_vm._v(_vm._s(_vm.step.matter.length) + "/5000")]
                )
              ])
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("label", { attrs: { for: "tags" } }, [_vm._v("Etiquetas")]),
              _c("vue-tags-input", {
                staticClass: "w-100 b-radius",
                attrs: {
                  id: "tags",
                  "data-cy": "tags",
                  name: "tags",
                  tags: _vm.step.tags,
                  placeholder: "Agregar",
                  separators: [","]
                },
                on: {
                  "tags-changed": function(newTags) {
                    return (_vm.step.tags = newTags)
                  }
                },
                model: {
                  value: _vm.tag,
                  callback: function($$v) {
                    _vm.tag = $$v
                  },
                  expression: "tag"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Es documento madre" } },
                [
                  _c("v-select", {
                    staticClass: "w-100 b-radius",
                    attrs: {
                      "data-cy": "is-mother",
                      options: _vm.optionsMother,
                      clearable: false,
                      reduce: function(option) {
                        return option.id
                      }
                    },
                    model: {
                      value: _vm.step.isMother,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "isMother", $$v)
                      },
                      expression: "step.isMother"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        !_vm.validMother
          ? _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: !_vm.validMother },
                        expression: "{ required: !validMother }"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "off",
                      "data-cy": "mother-document-number",
                      label: "Nº Documento Madre (*)",
                      "data-vv-as": "documento madre",
                      name: "documentNumberMother",
                      danger: _vm.errors.has(
                        "step-1-part-1.documentNumberMother"
                      ),
                      "danger-text": _vm.errors.first(
                        "step-1-part-1.documentNumberMother"
                      )
                    },
                    on: {
                      keyup: function($event) {
                        return _vm.searchForMother()
                      }
                    },
                    model: {
                      value: _vm.step.documentNumberMother,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.step,
                          "documentNumberMother",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "step.documentNumberMother"
                    }
                  }),
                  (_vm.motherDocumentsList.length > 0 ||
                    _vm.loadingMotherDocuments) &&
                  _vm.showListSelect
                    ? _c(
                        "ul",
                        { attrs: { id: "list" } },
                        [
                          _vm.loadingMotherDocuments
                            ? _c("li", [
                                _c("span", { staticClass: "muted-light" }, [
                                  _vm._v("Buscando...")
                                ])
                              ])
                            : _vm._e(),
                          _vm._l(_vm.motherDocumentsList, function(item) {
                            return _c(
                              "li",
                              {
                                key: item.numero,
                                on: {
                                  click: function($event) {
                                    return _vm.setDocumentMother(item)
                                  }
                                }
                              },
                              [
                                _c("span", [_vm._v(_vm._s(item.numero))]),
                                _c("span", { staticClass: "muted-light" }, [
                                  _vm._v(
                                    " creado el " +
                                      _vm._s(
                                        _vm.formatDate(item.fechaCreacion)
                                      ) +
                                      " "
                                  )
                                ]),
                                _c("span", { staticClass: "muted-light" }, [
                                  _vm._v(
                                    " nº interno " +
                                      _vm._s(item.numeroInt) +
                                      " "
                                  )
                                ]),
                                _c("p", [
                                  _vm._v("Creado por "),
                                  _c("b", [
                                    _vm._v(_vm._s(item.solicitanteNombre))
                                  ]),
                                  _vm._v(
                                    " (" + _vm._s(item.solicitanteEmail) + ")"
                                  )
                                ])
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.error.message
                    ? _c("small", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.error.message))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("label", [_vm._v("Fecha Documento Madre")]),
                  _c(
                    "b-form-datepicker",
                    _vm._b(
                      {
                        attrs: {
                          "today-button": "",
                          "reset-button": "",
                          "close-button": "",
                          max: _vm.maxDate,
                          locale: _vm.locale,
                          "show-decade-nav": false,
                          "hide-header": false
                        },
                        model: {
                          value: _vm.step.issueDateMother,
                          callback: function($$v) {
                            _vm.$set(_vm.step, "issueDateMother", $$v)
                          },
                          expression: "step.issueDateMother"
                        }
                      },
                      "b-form-datepicker",
                      _vm.labels[_vm.locale] || {},
                      false
                    )
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _c("div", { staticClass: "row mb-3" }, [
          _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
        ])
      ]
    ),
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "step-1-part-2", autocomplete: "off" },
        on: {
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
          }
        }
      },
      [
        _vm._m(0),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("list-document-types", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "relatedDocumentType",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Tipo Documento",
                  "data-cy": "relate-document-type",
                  name: "relatedDocumentType",
                  danger: _vm.errors.has("step-1-part-2.relatedDocumentType"),
                  "danger-text": _vm.errors.first(
                    "step-1-part-2.relatedDocumentType"
                  ),
                  "data-vv-as": "tipo documento"
                },
                model: {
                  value: _vm.relatedDocument.type,
                  callback: function($$v) {
                    _vm.$set(_vm.relatedDocument, "type", $$v)
                  },
                  expression: "relatedDocument.type"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label: "Nº Documento",
                  "data-cy": "related-document-number",
                  name: "relatedDocumentNumber",
                  danger: _vm.errors.has("step-1-part-2.relatedDocumentNumber"),
                  "danger-text": _vm.errors.first(
                    "step-1-part-2.relatedDocumentNumber"
                  ),
                  autocomplete: "off"
                },
                model: {
                  value: _vm.relatedDocument.number,
                  callback: function($$v) {
                    _vm.$set(_vm.relatedDocument, "number", $$v)
                  },
                  expression: "relatedDocument.number"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            {
              staticClass: "col-12 d-flex align-items-end justify-content-end"
            },
            [
              _c(
                "vs-button",
                {
                  attrs: {
                    "data-cy": "add-relation",
                    color: "primary",
                    icon: "add"
                  },
                  on: {
                    click: function($event) {
                      return _vm.addRelatedDocument()
                    }
                  }
                },
                [_vm._v(" Agregar relación ")]
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "vs-table",
                {
                  staticClass: "pb-2 mb-2",
                  attrs: {
                    multiple: "",
                    "no-data-text": "No tienes documentos relacionados",
                    data: _vm.step.relatedDocuments
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var data = ref.data
                        return _vm._l(data, function(tr, indextr) {
                          return _c(
                            "vs-tr",
                            { key: indextr, attrs: { data: tr } },
                            [
                              _c(
                                "vs-td",
                                { attrs: { data: data[indextr].type } },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.findLabelDocument(tr.type)) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "vs-td",
                                { attrs: { data: data[indextr].number } },
                                [_vm._v(" " + _vm._s(tr.number) + " ")]
                              )
                            ],
                            1
                          )
                        })
                      }
                    }
                  ]),
                  model: {
                    value: _vm.step.relatedDocumentsSelected,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "relatedDocumentsSelected", $$v)
                    },
                    expression: "step.relatedDocumentsSelected"
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "thead" },
                    [
                      _c("vs-th", [_vm._v("Relacionado con")]),
                      _c("vs-th", [_vm._v("Nº Documento")])
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Documentos Relacionados")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }